import { useLang } from "../i18n/LangContext";
import { useReveal } from "../hooks/useReveal";

export default function Sectors() {
    const { t } = useLang();
    const { ref, className } = useReveal();
    return (
        <section
            data-testid="sectors-section"
            className="py-24 md:py-32 bg-paper-alt"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div
                    ref={ref}
                    className={`${className} grid lg:grid-cols-12 gap-12 items-start`}
                >
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="w-10 h-px bg-ink" />
                            <span className="font-display text-xs uppercase tracking-[0.3em] text-ink-muted">
                                {t.sectors.kicker}
                            </span>
                        </div>
                        <h2 className="font-display font-bold uppercase text-4xl md:text-5xl leading-[0.95] tracking-tight text-ink">
                            {t.sectors.title}
                        </h2>
                    </div>
                    <div className="lg:col-span-7">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 border-t border-l border-ink">
                            {t.sectors.items.map((s, i) => (
                                <div
                                    key={i}
                                    data-testid={`sector-${i}`}
                                    className="border-r border-b border-ink p-6 bg-white hover:bg-mint-soft transition-colors flex items-center justify-between group"
                                >
                                    <span className="font-display text-base md:text-lg uppercase tracking-tight text-ink">
                                        {s}
                                    </span>
                                    <span className="font-display text-xs text-ink-muted">
                                        0{i + 1}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
